import { Days } from '@e3dc-react/shell/Libs/date/types'
import { Moment } from '@e3dc-react/shell/Libs/moment'

export enum RepeatOptions {
  doNotRepeat = 'doNotRepeat',
  daily = 'daily',
  weekly = 'weekly',
}

export type RepeatOptionsType = (typeof RepeatOptions)[keyof typeof RepeatOptions]

export interface ChargingScheduleFormType {
  scheduleName: string | null
  targetStateOfCharge: number | null
  startDate: Date
  startTime: Date
  enabled: boolean
  endDate: Date | null
  repeat: RepeatOptionsType
  selectedWeekDays: Days
}

export enum ChargingScheduleFormFieldNames {
  ScheduleName = 'scheduleName',
  TargetStateOfCharge = 'targetStateOfCharge',
  StartDate = 'startDate',
  StartTime = 'startTime',
  Enabled = 'enabled',
  EndDate = 'endDate',
  Repeat = 'repeat',
  SelectedWeekDays = 'selectedWeekDays',
}

export type ChargingScheduleFormDataType = string | number | Date | Moment | boolean | null | Days

export type ScheduleCounter = {
  weekly: number
  daily: number
  oneTime: number
}
